import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/SearchBoxV2/component.tsx");
